import Vue from 'vue';
import Component from 'vue-class-component';
import EdCreateProductComponent from '@/courses/components/ed-create-product/ed-create-product.component.vue';
import { ALL_CONTENT_ROUTES } from '@/app/private/my-content/views/all/all.router';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { COURSE_TEMPLATE_EVENTS, PRODUCT_TYPES } from '@/course-templates/values/course-templates.values';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { Status } from '@/models/status.model';
import { CORE_ROUTES } from '@/core/core.router';
import { CourseTemplateService } from '@/course-templates/services/course-templates.service';

@Component({
  name: 'build-subject-description',
  components: {
    EdCreateProductComponent
  },
})
export default class BuildSubjectDescriptionView extends Vue {

  public status: Status = new Status();
  public productType: any = PRODUCT_TYPES.BUILD;
  public template: any = {};
  public subject = {};
  public disabledSubjectForm: boolean = true;
  public saving: boolean = false;

  /* Computed */
  get templateId(): number {
    return  Number(this.$route.params.id);
  }

  public goBack() {
    this.$router.push({ name: ALL_CONTENT_ROUTES.TEMPLATES.NAME });
  }

  async getTemplateDescription() {
    if (this.templateId) {
      try {
        await this.setTemplateDescriptionFromTemplate(this.templateId);
      } catch (err){
        this.$EdToast.create({ 
          msg:  `${this.$t('courseTemplates.errors.errorLoadingCourseTemplate')}`,
          type: TOAST_TYPES.DANGER,
          top: '3rem',
          timeout: 3000
        });
      }
    }
  }

  async setTemplateDescriptionFromTemplate(templateId: number) {
    const response = await CourseTemplateService.getCourseTemplate(templateId);
    this.template = {
      id: response.contentId,
      title: response.contentTitle,
      img: response.coverThumbnailSmallUrl,
      defaultDueDateForTasks: response.defaultDueDateForTasks,
      defaultLastDateForTasks: response.defaultLastDateForTasks,
      contentSummary: response.contentSummary,
      categoryId: response.category.id,
      imgHash: response.coverImg,
      hasGrading: response.hasGrading,
      actualGrade: response.actualGrade,
      suggestedGrade: response.suggestedGrade,
      schoolDay: response.schoolDay,
      duration: response.duration,
      components: response.components
    }
  }

  saveSubjectDescriptionClick() {
    this.$edEventBus.$emit(COURSES_EVENTS.SUBJECT_DESCRIPTION_BUILDER);
  }
  
  async saveSubjectDescription({formData, uploadedImage}) {
    try {
      this.saving = true;
      this.subject = {
        ...formData,
        title: formData.contentTitle,
        img: formData.coverImageUrl,
        imgHash: formData.coverImg,
        actualGrade: formData.actualGradeId,
        suggestedGrade: formData.suggestedGradeId
      };
      let req = {
        templateId: this.templateId, 
        subject: this.subject,
        coverImage: uploadedImage?.file,
        componentsSelected: formData.componentsSelected
      }
      let res = await this.$Courses.Services.buildSubjecFromTemplate(req);
      this.$router.push({ 
        name: CORE_ROUTES.COURSE.NAME,
        params: { courseId: res.contentId, mode: 'edit' } 
      });
      this.saving = false;
    } catch(err) {
      this.saving = false;
      this.$EdToast.create({ 
        msg:  `${this.$t('courses.subjectBuilder.errors.errorBuildingCourse')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
  }

  async mounted() {
    await this.getTemplateDescription();
  }

  created() {
    this.$edEventBus.$on(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM, this.saveSubjectDescription);
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM);
  }

}